import { render, staticRenderFns } from "./questionType.vue?vue&type=template&id=5b37bcd2&scoped=true&"
import script from "./questionType.vue?vue&type=script&lang=js&"
export * from "./questionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b37bcd2",
  null
  
)

export default component.exports